import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  pure: true,
})
export class SafeHtmlPipe implements PipeTransform {
  public constructor(private readonly _sanitizer: DomSanitizer) { }

  public transform(value: any): any {
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}
